import { createSelector } from '@ngrx/store';
import { selectProfileState } from './profile/profile.selector';
import { selectCompanyState } from './company/company.selector';
import { UserRole } from '../models/user.model';
import { LoadingState } from './store.states';

export const selectProgress = createSelector(
  selectProfileState,
  selectCompanyState,
  (profile, company) => {
    return {
      profileComplete: profile.completed,
      companyComplete: company.completed,
      progress:
        !profile.completed && !company.completed
          ? 30
          : profile.completed && !company.completed
            ? 40
            : profile.completed && company.completed
              ? 100
              : 0,
    };
  },
);

export const selectCompanyResolve = createSelector(
  selectProfileState,
  selectCompanyState,
  (profile, company) => {
    return {
      isReady:
        company.completed && profile.roleLoadingState === LoadingState.SUCCESS,
      companyComponent: company.completed && profile.role === UserRole.ADMIN,
      memberComponent: company.completed && profile.role !== UserRole.ADMIN,
    };
  },
);
